const Main = () => import("@/views/main.vue");
// tab切换
// const UserMain = () => import("@/views/user/userMain.vue");
// 列表
const Account = () => import("@/views/linan");


export default [
    {
        path: "/linanList",
        name: "linanList",
        component: Main,
        meta: {
            name: "临安统计信息",
            unfold: false, //是否可以被展开
            iconType: "usergroup-add"
        },
        redirect: {
            name: "linanList"
        },
        children: [
            {
                path: "linanList",
                name: "linanList",
                component: Account,
                meta: {
                    name: "统计信息",
                    role:{}
                }
            }
        ]
    }
];